import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";
import zIndices from "theme/zIndices";

const PageNav: React.FC<
  React.PropsWithChildren<BoxProps> & { isInternalAdminDashboardView?: boolean }
> = ({ children, isInternalAdminDashboardView, ...props }) => (
  <Box
    bg={isInternalAdminDashboardView ? "primary.700" : "white"}
    borderBottomWidth="1px"
    borderColor="gray.200"
    px="24px"
    minHeight="63px" // -1px to account for border
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    zIndex={zIndices.headerNav}
    {...props}
  >
    {children}
  </Box>
);

export default PageNav;
